module.exports = {
  message: {
    home:{
      title:"Hong Kong’s #1",
      subTitle:"Personalized Catering Service Provider"
    },
    client:{
      title:"Past Customers",
      nav:"PAST CUSTOMERS"
    },
    clinetContent:{
      partTitleOne:"Services and events",
      partContentOne:"Our food and service are all customer-focused, so all food can be delivered directly to your home, office or designated location. Our chef team has rich professional cooking experience, carefully selects ingredients to prepare delicacies from different countries, and also designs designated multi-person set meals for customers. You can choose our regular multi-person set meal, or you can choose your own specific set meal according to different party themes, to create a unique menu that is just right in your mind.",
      activity:{
        activityName:"Event:",
        activityService:"Set Meal:",
        activityNumber:"Number of Participants:",
        partTitleOne:"Clockenflap in Central",
        partServiceOne:"Fresh Salads, Hot Soup, Meat, Pasta, Fried Rice and Desserts",
        partTitleTwo:"New Global Headquarters Grand Opening",
        partServiceTwo:"French Pastry, French Tarts, Cookies, Chinese Pastry and Sandwiches",
        partTitleThree:"Race Festival",
        partServiceThree:"Bite-Size Appetizers, Snack Platter, Confectionery and Drinks",
        partTitleFour:"Staff Meal of Hospital Authority",
        partServiceThour:"Custom Made Bento Box",
        partTitleFive:"GRAVITY Grand Opening",
        partServiceFive:"Bite-Size Appetizers, Cold Cut Platter, Cinnamon Roll and Juice Bar",
        partTitleSix:"Kai Tak Cruise Terminal Event",
        partServiceSix:"Pasta, Fried Rice, Cold Cut Platter, Fresh Salads and Mini Cakes",
    }
  },
    waring:{
      h11:"爲確保服務質素",
      h12:"以下時段已經截單",
      h13:"18/9(六) 17:00-19:00",
      h14:"21/9(二) 18:00-23:59",
      h15:"不再接受新訂單",
      h16:"請選擇其他可預訂之時段",
      h17:"感謝您支持到會家",
    },
    meta: {
      index: {
        title: "Hong Kong’s #1 Catering Service Provider - Cateraway",
        description:
          "Hong Kong’s #1 Catering Service Provider. We provide personalized catering services, corporate & events catering services. Trusted by AIA, BEA, and over 700K customers. Deliver to HK Island, Kowloon, and NT. Suitable for wedding parties, junk boat parties, birthday parties, etc. Order Now.",
        keywords:
          "catering,catering hk,catering service,catering service provider,catering service company,catering service hk,catering service hong kong"
      },
      menu: {
        title: "Personalized Food Catering Menu - Cateraway",
        description:
          "We offer a variety of menus for you to cater for different occasions including private parties, business meetings, kids’ birthday parties, junk boat parties, or cocktail parties etc. Pick your dish at an affordable price. Deliver to Hong Kong Island, Kowloon and New Territories. Order Now.",
        keywords:
          "To the menu, to the menu, the price to the meeting, to the meeting"
      },
      enquiry: {
        title:
          "Meeting Quote|Quote Service Promotion - Go to the House Cateraway",
        description:
          "Specialize in more than 30 different types of business event catering quotes, food and services including chefs, Canapés, Finger Food, company opening, cocktail party, lunch, large events, snack platter, anniversary party, etc., provide 1 to 1 The special person will come to the conference quotation service.",
        keywords:
          "Event catering offer, quotation service, chef ready, Canapés, company opening, cocktail party, large event"
      },
      corporateCatering: {
        title: "Corporate Catering Service Hong Kong - Cateraway",
        description:
          "Cateraway have been featuring corporate catering service over 300 company since . Cost performance would be our issue of great concern, which restructure corporate catering service to attract companies. The company’s budget and the quality of the food turns out that there are great success with corporate catering hk. Our chiefs have more than 20 years experience in different countries style food. Therefore, it is so common that our menu have different countries cuisine combined in the same dish or platter. In the aspect of food safety, there is no doubt that we are paying great attention on and we are professional. The reason is that we are one of the partner of Hospital Authority which need high qualification and standard on food. Our companies used to take part in major events, for example: Central AIA carnivals, marathons, Clockenflap, Cirque du Soleil, 18+ Central  etc. Most of the events were holding in Central and we were serving 200 to 2000 ppl for their meal.",
        keywords:
          "corporate catering,corporate catering service,corporate catering hk "
      },
      contact: {
        title:
          "Contact Us|All Hong Kong Catering Conference - To the House Cateraway",
        description:
          "There is a self-contained food factory in the meeting house, which can cook 2-2000 people in different forms. We have long-term cooperation with more than 100+ Partyrooms, and we have cooperated with different event planning companies. Many large-scale events in Central include AIA Carnival and Clockenflap. Any company is welcome to contact us for long-term service.",
        keywords:
          "Food and beverages, contact us, Hong Kong to the meeting, Chinese menu, Western menu"
      },
      blog: {},
      partyFood: {
        title: "Party Food & Canape Delivery Hong Kong - Cateraway",
        description:
          "Cateraway provides personalized Party food and Canape services. Tailor made the food menu for your parties. Our catering experts have thirty years+ catering experience. Delivery to the whole Hong Kong. Order Now.",
        keywords: "Party Food, Party Catering"
      },
      christmasParty: {
        title: "聖誕到會 | 聖誕節派對更難忘精彩 - 到會家 Cateraway",
        description:
          "聖誕節就嚟到啦，搞Party活動需要聖誕到會？到會家提供聖誕限定平價到會大餐，自由任選1人1款皇牌聖誕到會，聖誕必備火雞，聖誕Cupcake等。是聖誕聯歡會、公司Party、聖誕Party首選！送運至全港九新界，立即訂購！",
        keywords: "聖誕到會 聖誕派對"
      },
      birthdayParty: {
        title:
          "Birthday to the party|Children‘s birthday party - to the party Cateraway",
        description:
          "To the family’s main year of children‘s birthday to the meeting, the menu design has added a variety of hormone-free and nutritious ingredients for children, so that parents and children can have a happy and healthy birthday, a Get up and witness the laughter of the child",
        keywords: "Birthday, children’s birthday party"
      },
      junkCatering: {
        title:
          "Junk Boat Party Catering Packages - Cateraway",
        description:
          "Cateraway provides personalized Junk Boat Party food services. Tailor made the food menu for your parties. Our catering experts have thirty years+ catering experience. Delivery to the whole Hong Kong. Order Now.",
        keywords: "Junk Boat Party Food, Junk Boat Party Catering"
      },
      weddingCatering: {
        title: "Wedding Catering Service | Wedding Party - Cateraway",
        description:
          "Cateraway provides personalized wedding catering services. Tailor made the food and drink menu for your dream wedding banquet. Wide range of cuisine including Thai, Western, Chinese, Vegetarian food that fit the theme of your wedding party. Delivery to the whole Hong Kong. Order Now.",
        keywords: "Wedding is coming, wedding will be recommended"
      },
      chineseCatering: {
        title: "Chinese to the meeting - to the club Cateraway",
        description:
          'There is 30 years of Chinese food experience. The chef is responsible for Chinese cuisine, vegetarian dishes and traditional homemade dishes. Chinese chefs will personally edit the Chinese style menu. If there are too many friends and relatives, it will be fast. Order our Chinese food and send it to the government for the "Geng" festival!',
        keywords: "Chinese to the meeting"
      },
      westernCatering: {
        title: "Western style to the meeting - to the club Cateraway",
        description:
          "Western style dinner menu is designed by chefs with more than 20 years of western experience. We also have fine Western snacks, cup snacks, advanced business snacks, finger food and canapés. Let us design a Western-style meal menu for your company‘s activities.",
        keywords: "Western style to the meeting"
      },
      halloween: {
        title: "Halloween Party Catering | Halloween Caterer - Cateraway",
        description:
          "Cateraway provides Halloween catering services for your Halloween Parties. Cateraway’s Halloween menus serves gourmets from Thai food, Chinese, Western, Vegetarian and a lot more. Deliver straight at your doorstep. Order Now",
        keywords: ""
      },
      thaiCatering: {
        title: "Thai-style meeting - to the club Cateraway",
        description:
          "The Thai-style menu to the club is also jointly developed by the company’s Thai restaurant chefs. All the Thai styles are completely Thai! Thai food is recommended for Thai fried Phnom Penh powder, Thai pork neck meat, traditional pineapple fried rice and coconut milk layer cake.",
        keywords: "Thai style to the meeting"
      },
      vegetarianCatering: {
        title: "Vegetarian at the meeting - to the club Cateraway",
        description:
          "In addition to the meat-free selection in the Royal Restaurant menu, we can also cook Chinese vegetarian and Western vegetarian food. We sincerely invite many years of Western vegetarian experience chefs to spend 2 years to select materials to prepare their own vegetarian food, health begins with food!",
        keywords: "Vegetarian to the meeting"
      },
      bento: {
        title: "Big Ben | Bento Box - Go to the House Cateraway",
        description:
          "To the club will design a perfect lunch box for each colleague and supervisor of your company. This will be an experience from the former to the dessert. If you would like to order a lunch for your company, please contact us! This will be a food that carries love and heart!",
        keywords: "便当"
      },
      centralAndWestern: {
        title: "Central to the meeting - to the club Cateraway",
        description:
          "To the club‘s franchise, more than 100 Central companies have attended the conference, including the Clockenflap Music and Culture Festival, AIA Carnival, Central Sun Theatre, 18+Central, Corporate Cocktail Club, Corporate Business Conference, etc.",
        keywords: "Central to the meeting"
      },
      eastern: {
        title: "North Point to the meeting - to the club Cateraway",
        description:
          "To the club is committed to delving into the North Point to the new cuisines of various chambers of commerce and schools, chamber services such as cocktail parties, large-scale business meetings, boat P, banquets, regular meetings, etc. are within the scope of our services, and other school festivals We can also serve you for parties such as parties, school games, and open days. ",
        keywords: "North Point to the meeting"
      },
      wanChai: {
        title: "Causeway Bay to the meeting - to the club Cateraway",
        description:
          "To the meeting, the chefs will personally supervise the procedures for the arrangement, processing and processing of the ingredients, ingredients, snacks and desserts in Causeway Bay! Catering services are provided in company lectures, sharing sessions, banquets, ceremonies, yacht clubs and other activities.",
        keywords: "Causeway Bay to the meeting"
      },
      kwunTong: {
        title:
          "Kwun Tong, Ngau Tau Kok, Kowloon Bay Catering Service - Cateraway",
        description:
          "Cateraway provides catering services to Kwun Tong, Ngau Tau Kok, and Kowloon Bay. Customize your corporate catering services, business events at Kwun Tong area including business lunches, cocktail parties, or breakfasts for morning meetings. Order Now.",
        keywords: "kwun tong catering "
      },
      shamShuiPo: {
        title: "Changsha Bay is here - to the club Cateraway",
        description:
          "To the club is dedicated to commercial, residential, industrial and other places to provide $82 / inexpensive Changsha Bay and Lai Chi Kok service, the menu includes multi-national specialties such as Thai pineapple fried rice, Doka Kabang Nichangtong powder is a popular choice for Changsha Bay",
        keywords: "Changsha Bay to the meeting"
      },
      yauTsimMong: {
        title:
          "Tsim Sha Tsui to the meeting | Mong Kok to the meeting - to the club Cateraway",
        description:
          "To the family, we have collected dishes from different countries and regions, and selected a market suitable for Tsim Sha Tsui to attend the meeting and Mong Kok to produce unique dishes. For $82, you can experience the first dish, main course and snacks. Dessert down to transport one-stop service.",
        keywords: "Tsim Sha Tsui to the meeting, Mong Kok to the meeting"
      },
      kwaiTsing: {
        title: "Kwai Chung to the meeting - to the club Cateraway",
        description:
          "More than 50 foods are available for you to choose from Kwai Chung! The chef of the 30-year-old chef is in charge of Chinese, Western and Thai styles. If you want to order Kwai Chung to the food, in addition to the telephone reservation, you can also book food on the website of the club, mentioning that you remember to book three days in advance! ",
        keywords: "Kwai Chung to the meeting"
      },
      saiKung: {
        title:
          "Saigon to the meeting | Tseung Kwan O to the meeting - to the club Cateraway",
        description:
          "Specially provide Saigon to the meeting, Tseung Kwan O to the meeting, Kangcheng and Baolin to meet, meet your boat P, beach picnic, family gatherings, boat rivers and so on. For just $82, you can choose from over 50 different food combinations to suit your preferences.",
        keywords: "Saigong to the meeting, Tseung Kwan O to the meeting"
      },
      shaTin: {
        title: "Shatian to the meeting - to the club Cateraway",
        description:
          "The reason why the family is the first choice for family guests in Shatian is that we have a wide variety of foods, from top dishes to desserts with more than 50 dishes. Each dish is hosted by a 20-year Western restaurant chef and is considered for every member of your family. Call now or book online! ",
        keywords: "Shatian to the meeting"
      },
      tsuenWan: {
        title: "荃湾到会- To the club Cateraway",
        description:
          "The best choice for the restaurant in Tsuen Wan, the $82 optional menu from desserts, staple foods, snacks are suitable for different age groups. Every six months, a new trend menu will be launched, and customers will have different experiences every time, and present a variety of foods in front of you.",
        keywords: "荃灣到會"
      },
      tuenMun: {
        title: "屯门到会- To the House Cateraway",
        description:
          "The 100 unique foods for the friends who come to Tuen Mun, the global distribution of food. Including different famous restaurants, trendy specialties, and punched desserts, there are also exclusive teams to send you hot food, pick it up!",
        keywords: "屯門到會"
      },
      yuenLong: {
        title: "Yu Long arrives at the meeting - Go to the House Cateraway",
        description:
          "To the club Yuen Long to the exclusive team to serve you, friends in Yuen Long no longer have to worry about the regional problems! At the meeting, you can collect Chinese, Western, Thai and Japanese specialties, and you can try out different specialty snacks, staple foods, desserts, vegetarian foods, etc. in different countries!",
        keywords: "Yuanlang to the meeting"
      }
    },
    camenu: {
      span1: "Recommended person",
      span2: "Price",
      span3: "Free Delivery",
      btn: "View Details",
    },
    halloweenweb: {
      h1: "Halloween Party Catering",
      h2:
        "Cateraway is the pick of catering companies for your Halloween Party",
      btn: "Order Now",
      section1h2: "Trick or treat the Halloween",
      section1p:
        "Let's celebrate this fun time with our wonderful halloween catering! Host your parties, get the halloween catering delivery at your doorstep, dress with halloween costume. Cateraway provides a wide range of cuisines, not only limited to Thai, Chinese, Western and Vegetarian style. Customize your Halloween party and treat yourself.",
      section2h2: "Must-Eat At Your Halloween Party",
      section2h3_1: "Steamed Pumpkin And Sweet Potato",
      section2h3_2: "Chocolate Brownie",
      section2h3_3: "Mini Banana And Purple Potato Oats Ball",
      section2p1:
        "How can you have a Halloween without pumpkin? This fresh pumpkin potatoes with honey are a perfect match!",
      section2p2:
        "Have a chocolate brownie to do the “Trick or Treat!” . It is just so yummy that everybody wants a treat!",
      section2p3:
        "The delightful Mini Banana with Purple Potato Oats Ball is just good for all the grown-ups and kids.",
      section3h2: "Halloween Party food for you",
      section3p:
        "Our catering experts have thirty years+ catering experience. We are happy to make Halloween parties catering for you according to your essentials. Sit back and relax to enjoy a nice Halloween party with your friends.",
      tip: "Vanilla And Chocolate Profiteroles Giveaway Upon 14 Boxes+ Order!"
    },
    buttons:{
      whatsApp:"Whatsapp Order",
      linkButton:"Online Order",
    },
    giftArea:{
      gift:"GiftArea",
      title:"送禮專區 | 生日禮物 | 聖誕禮物 | 情侶送禮",
      banner:{
        title:"Gift Center",
        subTitle:"Cateraway provides Birthday Gift, Christmas Gift,  Men Gift, Women Gift！"
      },
      content:{
        title:"如何送最適合的禮物",
        p:"Cateraway is cooperating with Hong Kong Raw Honey to launch healthy and beneficial raw honey products. It has been certified by the Hong Kong Standards and Testing Center (STC) and Hong Kong General Testing and Certification SGS, which proves that the honey produced by Hong Kong Raw Honey is not processed and heated, sugar-free, and does not contain Sodium, no antibiotics, and no pesticides. Raw honey collected from local bee farms has strong antibacterial properties. Consume a spoonful of honey every day, which is helpful for the health care of freezing age. It contains flavonoids (the best antioxidants in nature), which have antioxidant activity. For men's gifts, women's gifts, gifts for the elderly, birthday gifts, Christmas gifts, etc. Honey is a sweet substance fully brewed by bees. It has a sweet taste, not only bringing you sweetness, but also meaning life Happy, sweet as honey! There is no doubt about the role of honey in beauty and beauty. In ancient times, Concubine Yang used honey for skin care, and many celebrities used honey for maintenance. Many people envy the growth of celebrities against their age. In fact, this stems from their correct health care methods. Honey is rich in antioxidants, which can remove excess free radicals in the body and delay ageing. Drinking honey water regularly can restore your skin to its suppleness. Nowadays, many people have bad eating habits, and overeating and unhealthy eating have become a very common thing in life. Gastrointestinal problems are bound to occur in the long run. The active enzymes contained in honey can maintain the secretion of gastric acid and help the stomach to break down and digest food. Drinking a glass of honey water when you have an upset stomach can not only relieve pain, but also warm your heart and stomach, and increase your favorability! Seeing so many benefits, are you still worried about giving the wrong gift? Don't know what gift to give? Order healthy and beneficial raw honey now, we provide door-to-door delivery services in Hong Kong, just search for birthday gifts, Christmas gifts, gifts for men, gifts for women, gift recommendations, etc. You can find us!"
      }
    },
    caterwayReserve:{
      marqueeTitle:{
        zero: "優惠",
        first: "選擇“地面交收”免運費",
        second: '使用消費券，輸入優惠碼：CV88 即享88折優惠',
        third: "玩船P 開Party 出示相關證明即送精選甜品",
        four: "凡於網站訂購到會套餐，輸入優惠碼：CASH100，即享HK$100現金減免",
        five: "凡於網站訂購到會套餐，輸入優惠碼：SNACK2023，即享滋味小食：香蒜蜂蜜BBQ脆炸雞中翼（12隻）一盤"
      },
      title:"到會餐牌 | 平價到會 | 船P到會 | 西式到會 | 公司到會 | 泰式到會",
      banner:{
        title:"全新到會餐單體驗",
        subTitle:"自選到會餐牌，總有一款適合你"
      },
      context:{
        h2TitleOne:"平價到會 真係超值!",
        pContentOne:"我們不只到會平，物美價廉，而且在到會餐單設計方面一直都沿用著創新的思維和方法，每一款食物都經過多次試驗，為求您的活動可以變得更完美。我們在設計每一款的到會餐牌的時候，都是由我們的中、西式及泰式廚師代表共同開發，而每一位廚師平均都是有最少10年的廚房經驗，因此不少客人都對我們的餐牌感到十分滿意。",
        h2TitleSecond:"到會餐牌菜式多元 老少咸宜",
        pContentSecond:"不少客人都認為我們的菜式多元，不只有傳統美食，亦包含各國食物的特色，這絕對是我們的到會餐牌優勝之處。我們深明每個人都有各自的飲食喜好及要求，因此我們設計餐牌時，會加入不同食物類型、各國菜式，我們甚至設計出素食到會餐單，以滿足香港一眾食客的需求。",
        pContentSecondTwo:"我們在到會餐單設計方面一直都沿用著創新的思維和方法，每一款食物都經過多次試驗，由十多年經驗的大廚主理，並特意誠邀泰國名廚協助製作出香港一眾素食者的喜愛。",
        h2TitleThird:"平價到會 親民價錢 高級享受",
        pContentThird:"另外我們有不同的餐單類型，包括私人、商務、小朋友派對、船P及午餐會等等活動類型的到會餐牌，一些餐牌都是只需約$82/位就可以品嚐美食。而且每一款類型的餐單，我們都會有相對平價到會，令您可以根據您的活動選擇適合的到會平價美食。在每一份的到會餐單中，我們會根據客人的活動形式加設對應的服務，例如在午餐會中，我們可以提供侍應生服務客人、及對應的酒水等等餐單要求。"
      },
      aboutMenuTitle:"關於訂購及餐單 - 常見問題:",
      aboutMenu:{
        faq1:"1. 為何選擇我們的到會餐單？",
        content1:"選擇我們的餐單原因很簡單，就是菜式種類多、到會平價、收費相宜。我們提供的食物類型絕不單一，從沙律，冷盤、小食，到粉麵、飯類、甜品，選擇包羅萬有，而且我們的廚師定期會更新到會餐單，加入新創菜式，給予客人更多選擇，新鮮感十足。除此之外，我們提供價錢相對相宜的到會平價套餐，讓客人能在有限預算內品嚐得到富有質素的食品。",
        faq2:"2. 我們的到會餐牌一般可供多少人食用？ ",
        content2:"我們有不同份量的餐牌供選購，從10至20人的小型派對、到多達60至70人大型活動，我們都應付有餘。換句話說，不論活動人數多寡，我們都能提供相應的到會份量，滿足食客要求。",
        faq3:"3. 如何選擇高質素的平價到會？",
        content3:"市面上有不少公司都標榜提供平價到會選擇予客人，而曾有客人向我們反映到會平價、質素不一定好的經歷，有些公司提供到會平價餐，但食物選擇極少，食材用料亦不新鮮，甚至發生延遲運送等問題。要揀選高質素的平價到會，首先細閱其到會餐單，看看食物類型，是否非常單一、抑或有很多選擇？其次，了解當中的條款及細節，例如提供送貨服務與否。最後，查看客人的評價，參考實際評語能助你分辨出到店家食物及環境質素。",
        faq4:"4. 到會家的平價到會設送貨服務嗎？",
        content4:"我們除了提供美食外，亦設送貨服務，不論是到會平價套餐，或是標準價錢餐單，都由我們特別安排的速遞員，將暖呼呼的食物送遞至客人手上。特別地址如村屋，碼頭、或其他偏遠地區，請於下單時與我們的專員查詢送貨詳情，我們將盡力為您安排。",
      },
    },
    menuh1: "Personalized Food Catering Menu",
    menuh: "Personalized Food Catering Menu",
    menuh2: "Food Catering That Caters All You Need",
    indextag: "Cateraway Personalized Catering Service",
    menutag: "Personalized food catering menu by Cateraway",
    wstag: "Halloween Party Catering Service",
    kwuntag: "Kwun Tong, Ngau Tau Kok, and Kowloon Bay catering",
    wedtag: " Wedding Catering by Cateraway",
    top: "Halloween Monster Profiteroles Giveaway Upon 14 Boxes+ Order! ",
    topbtn: "Shop Now",
    salad: "salad",
    staple: "staple",
    staple1: "staple1",
    staple2: "staple2",
    staple3: "staple3",
    special: "special",
    headplate: "headplate",
    pinpan: "snacks",
    snack: "snacks and platters",
    snack1: "snacks and platters1",
    snack2: "snacks and platters2",
    snack3: "snacks and platters3",
    sandwich: "sandwich",
    vegetables: "vegetables",
    dessert: "dessert",
    childrenarea: "childrenarea",
    coldplate: "coldplate",
    burger: "burger",
    addcommodity: "addcommodity",
    adddrinks: "adddrinks",
    addservice: "addservice",
    caterersmenu: {
      h1: "Junk Boat Catering Menu",
      h2: "Suitable for all kinds of Junk Boat Parties",
      h3: "POON CHOI Menu ",
      h4: "Good for small group and family gathering",
      btn1: "Shop Now"
    },
    footer: {
      telephone: "Telephone",
      whatsapp: "WhatsApp",
      address: "Address",
      address1:
        "Flat 12D, Block 1 Camel Paint Building, 62 Hoi Yuen Road, Kwun Tong",
      emali: "Emali",
      leixing: "License Number",
      gongsi: "Company Type",
      gongsispan: "Affiliates",
      terms: "terms and conditions",
      pri: "privacy policy"
    },
    nav: {
      btn1: "ENQUIRY",
      btn2: "ORDER",
      btn3: "BLOG",
      btn4: "GIFT",
      index: "HOME",
      attend: "ORDER",
      activity: "EVENT",
      cooperation: "CORPORATE",
      contact: "CONTACT",
      blog: "BLOG",
      party: "PARTY",
      christmas: "CHRISTMAS",
      birthday: "BIRTHDAY",
      boat: "BOAT P",
      wedding: "WEDDING",
      halloween: "HALLOWEEN",
      dishes: "CUISINE",
      snacks:"Snacks",
      chinese: "CHINESE STYLE",
      western: "WESTERN STYLE",
      thai: "THAI STYLE",
      vegetarian: "VEGETARIAN",
      bett: "BETT",
      area: "REGION",
      area1: "CENTRAL",
      area2: "NORTH POINT",
      area3: "CHEUNG SHA WAN ",
      area4: "KWUN TONG",
      area5: "CHANGSHA BAY",
      area6: "TSIM SHA TSUI",
      area7: "KWAI CHUNG",
      area8: "SAI KUNG",
      area9: "SHA TIN",
      area10: "TSUEN WAN",
      area11: "TUEN MUN",
      area12: "YUEN LONG"
    },
    Indexbanner: {
      h1: "Hong Kong’s #1",
      h2: "Catering Service",
      btn1: "Browse Menu",
      btn2: "WhatsApp Order"
    },
    Indexcontent: {
      h1: "Catering Services for Gatherings, Corporates, and Events",
      span1: "Personalized Catering",
      p1:
        "Easy ordering for your private parties, office lunches, or corporate events.",
      btn1: "Order Now",
      imgtag1: "Cateraway Personalized Catering Service",
      span2: "Events Catering",
      p2:
        "We provide personalized consultation giving you the best event catering solution.",
      btn2: "Quote Now",
      imgtag2: "Cateraway Events Catering",
      span3: "Business Corporations",
      p3:
        "Looking for regular catering services for your cocktail party or business lunch? We welcome opportunities to work with corporations.",
      btn3: "Talk to Us",
      imgtag3: "Cateraway Business Corporations "
    },
    Indexmenu: {
      h1: "A Catering Menu That Suits the Occasion",
      span1: "Private/Company Catering Services",
      span2: "Business Catering",
      span3: "Children Birthday Party Catering",
      span4: "Junk Boat Catering",
      span5: "Lunch Gathering Catering",
      span6: "Afternoon Tea Catering"
    },
    IndexText:{
      h2Banner:"Our catering services in Hong Kong are not just about food and beverage. Variety, new menu items, logistics and time management are all important to a successful catering service company. With vast experience as a catering service provider, we are the #1 choice for personal, corporate events and gatherings!",
      h2BannerSecond:"改變大眾對傳統香港到會質素參差的印象！到會家的美食到會推介經驗廚師精心設計，味道、香氣與口感均是我們所重視的。我們到會公司希望客人於家中、公司、甚至大型盛宴上都能像在餐廳一樣，吃到愉悅、滿足的味道。",
      h2menu:"Our catering services in Hong Kong are not just about food and beverage. Variety, new menu items, logistics and time management are all important to a successful catering service company. With vast experience as a catering service provider, we are the #1 choice for personal, corporate events and gatherings!",
      hezuo:"Over the years, our catering HK business has serviced large corporations such as AIA, Manulife, FWD, Construction Industry Council, HKU, Customs and Excise Department and IFC. We deliver to all 18 districts in Hong Kong, allowing private parties, corporates or public organizations to conveniently use our full range of catering service in Hong Kong.",
      faq:{
        headerTitle:"About Our Catering Services – FAQs:",
        aboutFoodTitle:"Ordering:",
        aboutFood:{
          faq1:"1. How can I place a catering order?",
          content1:"To place an order for catering services in Hong Kong, you can do so directly on our website through “Online Order”. Once on the order page, choose your dishes, enter the delivery address, date, time, customer name and contact number. After that, just select your preferred payment method and then you are all set!",
          faq2:"2. When is the latest I can place my catering order?",
          content2:"Our catering service company is open 365 days, 7 days a week, and we normally accept catering HK orders that are to be delivered the next day. However, to ensure our level of service and freshness, we highly recommend placing your order at least 2-3 days in advance. We also recommend placing your order earlier for weekends, special occasions, public holidays, and we reserve the right to not accept further catering service HK orders during periods of high demand.",
          faq3:"3. Are the catering food portions adequate?",
          content3:"We use 2- or 5-pound containers in our catering service for Hong Kong, and they do not necessarily reflect the actual weight of the food inside.",
          faq4:"4. I am unsure how much food I should order, can you advise?",
          content4:"Not to worry, as we have already pre-set our catering HK menu for different group sizes, such as 10, 20, 30 and 40 persons",
          faq5:"5. How is “one guest per dish” different to your catering set menus？",
          content5:"With “one guest per dish”, every guest can have the chance to choose a dish that he/she likes, so that everyone is happy. With our catering HK set menus, they are designed more towards catering to larger group sizes.",
          faq6:"6. How is Cateraway different from other catering service providers?",
          content6:"Traditional catering HK companies typically offer less choice in terms of their menu, and food portions are usually quite large. Our catering service in HK, on the other hand, offers more exciting menus with more choices, such as Western, Chinese, Thai and even vegetarian dishes. Also, we especially design new menus for special occasions, such as X’mas, Halloween, and New Year.",
          faq7:"7. I am spoiled for choice on your website, do you have any recommendations?",
          content7:"All our menus are carefully designed by experienced professionals who are not afraid to try something new. For weekly or seasonal recommendations, feel free to reach out to our catering HK team.",
          faq8:"8. How has your catering service company become so highly-recommended?",
          content8:"We have many years of experience in catering, and have served numerous private and corporate clients in the past. Our catering service HK team understands the importance of choice when it comes to designing our menus, and we are never afraid to mix and match, or try something new in our food options.",
          faq9:"9. Other than catering services, do you provide any supporting services?",
          content9:"As a full-range catering service provider, we can also arrange quality waiter services, catering tables and chairs, bartending, or on-site chefs upon request.",
          faq10:"10. Can I customize my catering HK order?",
          content10:"Of course. Our catering HK company understands that everyone has their preferences, and you are most welcome to reach out to our team for any special requests.",
          faq11:"11. Is food safety a high priority for your catering company?",
          content11:"We are very strict on ensuring food safety and quality of our catering service. We are a licensed catering company (No.: 295180786), and as a catering service company, we have food safety measures to control the process from selecting ingredients, to how the food reaches your home.",
          faq12:"12. Can I talk to someone from your catering service company?",
          content12:"Any time. We understand it can be quite a hassle when planning an event. Our catering service HK team is on hand to answer any questions you have and guide you through the ordering process.",
          faq13:"13. For more details, how can I reach out to your catering company?",
          content13:"You can contact our catering service company through various ways, such as through Whatsapp 6458 6539, or via email at cateraway.cs@funmaxhk.com."
        },
        aboutPaymentTitle:"Payment:",
        aboutPayment:{
          faq1:"1. What payment methods are available?",
          content1:"Our catering service company currently accepts Visa，Master Card，American Express, PayMe, FPS, Bank Transfer, and Alipay.",
          faq2:"2. Can I pay in cash?",
          content2:"Apologies, as we do not accept cash payments for catering services, and we only accept the payment methods listed above.",
          faq3:"3. Do you accept deposits when orders are placed, and then full payment upon delivery?",
          content3:"As there is a long process involved in sourcing ingredients and food preparation, we only accept full payment when catering HK orders are made.",
        },
        aboutDeliverTitle:"Delivery:",
        aboutDeliver:{
          faq1:"1. Is your catering service available anywhere in Hong Kong?",
          content1:"We are currently using a 3rd party catering HK delivery company, and they can reach most areas that are accessible by road, with a few exceptions. Please call our catering HK team for more details.",
          faq2:"2. What is the “Pickup Downstairs” option?",
          content2:"If “Pickup Downstairs” is selected as a delivery option, your catering HK order will be delivered without our driver entering your lobby, and rather the nearest car drop-off spot that is available. Please note that your order may be placed at your lobby (if applicable), or extra waiting charges applied, if the customer is unreachable.",
          content2Span1:"1. 如果目的地的大廈有大堂，會將食品寄托給他們作安排",
          content2Span2:"2. 依據物流平台 (例如Lalamove、GOGOX等) 的收費表，每隔5分鐘來收取等候費，大約為 10至15元不等，完成交收平台會向客人收取這等候費用",
          faq3:"3. Can I specify a delivery time for my catering service HK order?",
          content3:"Yes, you can. You can select a preferred delivery time when placing your catering HK order, from 10am to 7:30pm.",
          faq4:"4. Is delivery included with your catering service?\n",
          content4:"With catering orders totalling HK$1,600 or above, delivery is included (except for Tseung Kwan O and remote areas). With orders below HK$1,600, our catering delivery charges are as below:",
          content4Span1:"Kowloon Area – HK$150",
          content4Span2:"Hong Kong Island – HK$220",
          content4Span3:"New Territories – HK$210",
          content4Span4:"Note extra delivery charges may apply for remote areas. Please call our catering HK team for more details.",
          faq5:"5. Can I pick up my catering order in-store?",
          content5:"Catering service HK customers are welcome to pick up their order in-store at: Unit D, 12/F, Block 1, Camel Paint Building, 62 Hoi Yuen Road, Kwun Tong.",
          faq6:"6. May I authorize someone to pick up my catering order?",
          content6:"Yes, you may. Please ensure that the collecting party has the proper order confirmation details for verification purposes."
        },
        aboutToEatTitle:"Enjoying your order:",
        aboutToEat:{
          faq1:"1. Is cutlery included?",
          content1:"An adequate amount of cutlery and tongs are packaged with your catering order. Alternatively, you may opt to purchase more on the order page.",
          faq2:"2. Should the food be consumed soon upon arrival?",
          content2:"Our normal catering packaging is sufficient to keep the food warm for approx. 1 hour. Therefore, we recommend consuming the food soon after delivery.",
          faq3:"3. Can I reheat the food?",
          content3:"Yes, you can. To obtain the desired food temperature, you can reheat by microwave or oven after delivery.",
        },
        aboutOrderTitle:"Changing My Order:",
        aboutOrder:{
          faq1:"1. Can I change specific dishes after placing my catering order?",
          content1:"Changes to specific dishes after ordering are not allowed, and extra charges will be applied. As a full catering service provider, we do offer bespoke menus, and please reach out to our team for more details.",
          faq2:"2. Can I change the portions of specific dishes in my order?",
          content2:"This may be possible for selected dishes. Please reach out to our catering team for more details.",
          faq3:"3. I may have input wrong information while ordering, what can I do?",
          content3:"Upon discovery, please contact our catering service Hong Kong team directly via 6458 6539. We highly recommend customers to verify that all information is correct before placing their orders.",
          faq4:"4. Can I postpone or cancel my order?",
          content4Span1:"· Our catering company allows cancellation or postponement of orders if notified at least 3 days in advance, with a 30% surcharge applied.",
          content4Span2:"· If cancellation or postponement is within 3 days, no refunds will be provided.",
          content4Span3:"· Our catering service company reserves the right of final decision in such matters.",
          faq5:"5. How will my catering HK order be handled in cases of bad weather?",
          content5:"If the typhoon signal no. 8 or Black Rain signal is in force on the day of delivery, all orders can be postponed for a period of up to 90 days with no extra charge.",
        },
        faq3:"預訂到會有甚麼付款方式？",
        content3:"【答】為了讓客人能夠使用更完善的付款服務享用我們的到會推介，本公司提供了多種付款方式選擇，包括信用卡Visa，Master Card，American Express、PayMe、FPS轉數快、銀行轉帳、Alipay支付寶等等。",
        faq4:"美食到會全香港、九新、新界十八區都送嗎？",
        content4:"【答】我們採用第三方運輸團隊負責食物運送，全港可於路面運送的地區都可以送到。但偏遠地區如禁區、羅湖、沙頭角、迪士尼、機場、海洋公園、愉景灣、西貢北潭涌、黃石碼頭、離島、馬灣、摩口嶺、數碼港、貝沙灣、淺水灣、赤柱、石澳等，則需要額外收取運費或不能運送，詳情請向我們到會公司的客戶服務部查詢。",
        faq6:"套餐裡面的食物種類可以更改嗎？",
        content6:"【答】套餐類型的食物款式均不設更改，如需要更改同款類型的食物，每款需加$100以上的差額。我們更提供特別訂製的餐單服務，如有興趣，歡迎向我們到會公司的客戶服務部查詢有關報價。",
        faq7:"訂購到會美食會附上餐具嗎？",
        content7:"【答】我們到會公司會為每張訂單提供適量的餐具數量，每份餐具包含獨立包裝黑色硬身膠叉，濕紙巾，紙碟。",
        faq9:"取消訂單、更改訂單及訂單延期？",
        content9:{
          p1:"1. 訂單一經確認後，如需取消訂單或延遲訂單，請於 3 日前通知，我們到會公司並將會收取 30%手續費。",
          p2:"2. 若顧客於到會日期前少於 3 日通知取消訂單，已付金額將不獲退回。",
          p3:"3. 惡劣天氣安排：如到會當日，天文台懸掛八號以上暴風信號及黑色暴雨，顧客可選擇保留訂單及選擇原訂購日期起 90 天內延期。",
          p4:"4.本到會公司於訂購、細則及條款上保留最終決定權。",
        },
        faq10:"什麼是地面交收？",
        content10:"【答】若客人訂購到會美食時選擇「地面交收」，交收時送貨司機不會進入大堂，交收地點會在車輛可停泊位置，司機將接近收貨地點時會聯絡客人。",
        content10_1:{
          p1:"但司機在送貨時間內致電多次未能聯絡閣下，並且在到達時間後15分鐘內無法聯絡閣下／無法進行交收，送貨司機有權：",
          p2:"1. 將食物寄托在大堂或管理處 [如有]",
          p3:"2.  按物流平台 (e.g. Lalamove / GOGOX) 收費表每 5分鐘收取等候費用 $10 - $15，交收後平台會向客人收取等候費"
        }
      }
    },
    hezuo: {
      h2: "Clients of Our Catering Service Company",
      name1: "18+ Central",
      name2: "Royal Plaza Hotel",
      name3: "Pamela Youde Nethersole Eastern Hospital",
      name4: "The Bank of East Asia",
      name5: "FWD Life Insurance Company (Bermuda) Limited",
      name6: "United Christian Hospital",
      name7: "Construction Industry Council",
      name8: "Tseung Kwan O Hospital",
      name9: "The Salvation Army",
      name10: "Pokoi Charity Run 2019",
      name11: "Queen Mary Hospital",
      name12: "L'hotel",
      name13: "Four Seasons",
      name14: "City University of Hong Kong",
      name15: "The University of Hong Kong",
      name16: "The Hong Kong Society for Rehabilitation",
      name17: "Customs and Excise Department",
      name18: "Hong Kong Convention and Exhibition Centre",
      name19: "HKUST Business School",
      name20: "The Boys' and Girls' Clubs Association of Hong Kong",
      name21: "Clockenflap",
      name22: "CUHK Faculty of Medicine",
      name23: "Hong Kong Football Association",
      name24: "Heep Hong Society",
      name25: "Hospital Authority",
      name26: "Jardine OneSolution",
      name27: "Prudential",
      name28: "AIA",
      name29: "Amazon",
      name30: "Deutsche Bank",
      name31: "GAP",
      name32: "IFC",
      name33: "Kooza",
      name34: "Maersk",
      name35: "Menulife",
      name36: "PWC",
      name37: "Sports Federation _ Olympic  Committee of Hong Kong",
      name38: "volvo-ocean-race",
      btn: "More Clients"
    },
    blogs: {
      h1: "Food Guides",
      p: "News"
    },
    seo: {
      h1: "Hong Kong’s Top Personalized Catering Service Provider",
      p1:
        "Cateraway, as a catering service company, is dedicated to providing stylish and fabulous dishes for your parties, business functions, or events. Traditionally, catering service in HK could not provide a wide variety of options for customers. Let’s say with a 20-person private gathering, traditional catering service Hong Kong companies might only be able to offer 10 different types of dishes, which of course cannot satisfy the demand for high level menu personalization.",
      p2:
        "Cateraway’s unique catering model aims to provide the best-personalized catering services in Hong Kong. Our menu features a range of cuisines - from Thai, Chinese to Vegetarian catering services. We understand that choosing from several catering menus for different guests can be quite a hassle, that’s why we came up with the idea of each guest getting to choose one unique dish. For example, with 20 different dishes, at the competitive price of $82/dish, you can easily order for a 20-person party while satisfying everyone!",
      p3:
        "With an experienced team of culinary and catering service professionals, Cateraway has been a trusted catering service partner for numerous occasions as well as well-known clients including AIA, CUHK, BEA and a lot more. We are devoted to providing the best catering for your wedding, cocktail parties, birthday parties, junk boat parties, etc. Consult our catering specialist and place your order now!"
    },
    corporatebanner: {
      h: "Let’s be your partner",
      p:
        "We have long-term cooperation with more than 200+ different types of companies to ensure the best quality service",
      btn: "Contact Us"
    },
    corporatecontent: {
      h: "Let‘s be your partner",
      span1:
        "To the club and the more than 100+ Partyroom have a partnership to provide their guests with a very cost-effective meeting. If you have a friend who goes to Partyroom, I believe I will try our food",
      span2:
        "To the club has always worked with different event planning companies. Previously, many large-scale events in Central including AIA Carnival, Clockenflap, company opening ceremony and reception, construction industry council marathon and other activities provide food",
      pic2: "Event planning company",
      span3:
        "To the club is also working with a number of children’s theme venues, because our meeting is very suitable for children and adults to eat together. In the past, we have also provided food for many children’s graduation ceremonies and children’s birthdays",
      pic3: "Children‘s activity company",
      span4:
        "To the club and the gym together to develop a fitness menu, all fitness meals contain enough nutrients and protein to bring fitness after the exercise to the fitness people",
      pic4: "Fitness center",
      span5:
        "To the club is also a long-term partner of the Hospital Authority. Every day we provide a delicious lunch for the relevant departments, and we have confidence in food safety and quality control",
      pic5: "Hospital Authority",
      span6:
        "Our company has its own food factory, the chef is also familiar with the production methods of multi-national food, there are semi-finished products and full-made products for different restaurants, providing the efficiency of the restaurant",
      pic6: "restaurant",
      btn: "Contact your partner",
      seoh1: "Company arrives",
      seop1:
        "Cateraway have been featuring corporate catering service over 300 company since . Cost performance would be our issue of great concern, which restructure whole structure to attract companies. The company‘s budget and the quality of the food turns out that there are great success with corporate catering hk. There are different types of corporate catering we promised to attend include company opening ceremony, anniversary party, press conference, company product release conference, company party and company business evening party. Our services include providing event chef instant cook, buffet, finger food and canapés, we also provide red wine, white wine and cocktail. There are stoves and western-style tableware rental service for your event as well.",
      seop2:
        " Our companies used to take part in major events, for example: Central AIA carnivals, marathons, Clockenflap, Cirque du Soleil, 18+ Central  etc. Most of the events were holding in Central and we were serving 200 to 2000 ppl for their meal. As a catering food provider, we manage satisfied with our arrivals. The transform of the ready to serve buffet easily penetrated to the corporate catering field. We’ll help you customising a unique catering experience for the event complete with merging chefs,  waiter and equipment. Our chiefs have more than 20 years experience in different countries style food. Therefore, it is so common that our menu have different countries cuisine combined in the same dish or platter. In the aspect of food safety, there is no doubt that we are paying great attention on and we are professional. The reason is that we are one of the partner of Hospital Authority which need high qualification and standard on food.",
      seop3:
        "We do understand majority dishes doesn’t gravitate company attention while choosing corporate catering service. That is the reason why we feature those choices according to different event:",
      seop4: "* Business Package",
      seop5: "* Business Premium Buffet",
      seop6: "* Luncheon Buffet",
      seop7: "* Premium Lunch Buffet",
      seop8:
        "Whenever you’re looking for a corporate catering service, Cateraway is available to assist of your valuable needs. Your joy and peace drive us to participate any detail, in order to comfort the client’s need. Ready for your next event, contact us at +852 64586539 or text us via WhatsApp +852 64586539.",
      dialog: {
        h1: "Contact us",
        namelabel: "Calling",
        nameplaceholder: "Please enter your title",
        emaillabel: "Email",
        emailplaceholder: "Please enter your email",
        phonelabel: "Contact",
        phoneplaceholder: "Please enter your contact method",
        conlabel: "Company",
        conplaceholder: "Please enter the company name",
        coolabel: "cooperative",
        cooplaceholder: "Please enter a form of cooperation",
        btn1: "determine",
        btn2: "take away"
      }
    },
    party: {
      h: "Party Food & Canape Catering",
      p: "Cateraway provides catering services for more than 100+ private parties",
      btn: "Now Order",
      contenth1: "Specializing in Parties and Canape Catering Services",
      contentspan1:
        "Let's celebrate this fun time with our wonderful Party Food and Canape catering! Host your parties, get the parties catering delivery at your doorstep. Cateraway provides a wide range of cuisines, not only limited to Thai, Chinese, Western and Vegetarian style. Customize your private party and treat yourself.",
      contenth2: "Tailor-made Party & Canape food catering menu for you",
      contentspan2:
        "Cateraway provides special Chinese Catering menus. These menus are carefully crafted by chefs with 30+ years of experience in party cuisine. Share your meals with your friends and families warmly with Cateraway. In addition, we can also tailor-made Party food menus based on what you need.",
      contentspan3:
        "To be conclude, We meet the increasing demand of the party food delivery hk. Our profession is strive to feature the best option for all demands from our guests. Taking care of the party food delivery time and quality is an endless task. We are willing to receive feedback from each of our customers that they appreciate our food quality and service. Therefore, we spent a lot of time, passion as well as effort in each part of the customer’s journey.",
      lasth1: "Party Food Catering Happy gathering with your friends",
      context:{
        h2TitleOne:"擁有豐富製作Party到會的經驗",
        pContentOne:"我們是市場上屈指可數的領導者。在香港，我們固有的Partyroom場地合作伙伴超過150間，有不少首次接觸會家食物的客人均是於派對場合上，對我們的食物評價正面，及後再向職員查詢我們的聯絡方式，希望把這份吃到美食的快樂帶回家中及公司，讓其他親朋好友都可以感覺到。除了一般的partyroom，我們還與不同的小朋友場地提供者合作，因為我們的所提供的小朋友party到會都是可以滿足小朋友的選擇，我們設有兒童餐等等，令到成人的客人吃得開心同時，小朋友都可以吃得健康和美味。",
        h2TitleSecond:"不同派對食物任你選擇",
        pContentSecond:"一提到傳統派對食物，總不外乎pizza和炸雞等等，鮮有「party到會」的想法，但隨著市場發展，派對食物類型層出不窮，愈來愈多創新食品。到會慢慢從公司帶到家及其他聚會的地方，因此我們的一人一款派對食物是更能滿足到客人的需求，令到他們在不同的Party上，無論是在家、會所還是公司，都有一份全新的美味和多選擇的沖擊。在公司Party到會方面，部份客人都會選擇我們的原因是我們除了一般的菜式以外，我們還會設有finger food 和 canapes 等的食物，滿足更高級的享受。",
      },
      aboutPartyTitle:"關於訂購Party到會 - 常見問題:",
      aboutParty:{
        faq1:"1. 為何選擇我們的party到會？",
        content1:"我們擁有豐富製作派對食物的經驗，曾服務超過100個派對美食活動。我們所製作的party到會有別傳統，非常多元，部分菜式更來自日本、泰國等地，為客人帶來與別不同的新鮮感。",
        faq2:"2. 到會家的小朋友party到會與一般服務有什麼不同？",
        content2:"設計小朋友party到會套餐時，我們的廚師特別考慮到小朋友的飲食喜好，如喜歡吃小食、甜品，因此在小朋友party到會菜式上涵蓋多款美味小食如一口台灣小香腸、香脆墨魚角，還有孩子最愛的彩虹椰絲啫喱糖、朱古力雲呢拿泡芙等。而同時考慮到飲食均衡這項要點，除了小食與甜品外，餐單中還會有沙律及炒雜菜等健康選擇，讓小朋友吃得開心之餘，家長又放心。",
        faq3:"3. 我有喜歡的派對食物，可以放進餐單中嗎？",
        content3:"當然可以！辦派對當然要選自己喜歡的食物，我們提供度身設計餐單服務，歡迎您告訴我們您心目中的菜式要求，我們團隊會盡力配合，為您設計出專屬又可口的party到會菜單。"
      },
    },
    kwun: {
      h: "Best Catering Service in Kwun Tong, Ngau Tau Kok, and Kowloon Bay",
      p:
        "Cateraway has provided tailor-made catering services to 100+ companies",
      btn: "Order Now",
      contenth1: "Catering Service in Kwun Tong, Ngau Tau Kok, and Kowloon Bay",
      ctitle1:
        "Kwun Tong, Ngau Tau Kok, Kowloon Bay professionals catering service",
      ctitle2: "Tailor-made food catering menu for you",
      contentspan1:
        "Kwun Tong, Ngau Tau Kok and Kowloon Bay are the new central business districts in Hong Kong. Plenty of companies are situated in the Kwun Tong area. They have been our customers for years. We have experience in providing services for lunch meetings, cocktails parties and corporate events at Kwun Tong district.",
      contentspan2:
        "At Cateraway, we offer a range of food catering options, including Deluxe Exquisite Set, Business Buffet, Buffet for Company Opening Event and Afternoon Tea Package. We also offer a menu set for the party room at Kwun Tong, Ngau Tau Kok and Kowloon Bay district.",
      contentspan3:
        "Our catering experts have thirty years+ catering experience. Cateraway has been the catering service partner for numerous well-known clients including AIA, CUHK, BEA and a lot more. We are devoted to providing the best catering service for your morning meetings, team buildings and corporate events. Consult our catering specialist and order now! "
    },
    event: {
      bannerh1: "Event Catering Quote",
      bannerh2:
        "To the home service more than 100+ different sizes of activities",
      bannerbtn: "Submit event requirements",
      contenth1: "Quote service",
      contentp1:
        "Tell us about your event, let us provide you with the best food",
      contentspan1: "Customize your event food",
      contentsam1:
        "Please send us your event request, we will customize the food that suits you best according to your event",
      contentspan2: "1 to 1 dedicated service",
      contentsam2:
        "We will have a one-on-one service for your event to ensure the best service experience",
      contentspan3: "Multiple types of activity type",
      contentsam4:
        "We have provided food for different sizes, including Central AIA Carnival, Clockenflap, Construction Marathon and Company Opening",
      changetitle1: "Large event",
      changetitle2: "Business activity",
      changetitle3: "New Year‘s activities",
      changetitle4: "Lunch Meeting",
      change1: "Buffet",
      change2: "Chef is ready",
      change3: "athlete supplement",
      change4: "Canapés service",
      change5: "Lunch Club",
      change6: "Canapés",
      change7: "afternoon tea",
      change8: "Company opening",
      change9: "Buffet",
      change10: "Vegetable + table wine",
      change11: "Chinese style meal",
      change12: "Canapés and cocktail party",
      change13: "Western buffet",
      change14: "Bett",
      change15: "Tea Buffet",
      change16: "small food platter",
      dialog: {
        h1: "Contact",
        h2: "Event details",
        namelabel: "calling",
        nameplaceholder: "Please enter your title",
        emaillabel: "Email",
        emailplaceholder: "Please enter your email",
        phonelabel: "Contact",
        phoneplaceholder: "Please enter your contact method",
        conlabel: "company",
        conplaceholder: "Please enter company name",
        date1label: "date",
        date1placeholder: "Please select date",
        date2label: "time",
        date2placeholder: "Please select time",
        locationlabel: "Location",
        locationplaceholder: "location",
        numberlabel: "VIP number",
        budgetlabel: "Budget",
        budgetplaceholder: "Please enter the budget",
        foodlabel: "required",
        foodplaceholder: "Please enter the food you need",
        region1label: "food supply",
        region1placeholder: "Buffet, lunch box...",
        Drinklabel: "Beverages",
        Drinkplaceholder: "Please enter the required drink",
        Waiterlabel: "Waiter",
        Waiterplaceholder: "waiting for life",
        region2label: "device",
        region2placeholder: "long platform, hot furnace...",
        Claimlabel: "Claim",
        Claimplaceholder: "Please enter special request/arrangement",
        btn1: "determine",
        btn2: "take away"
      }
    },
    contact: {
      banner: {
        h: "New arrival experience",
        p:
          "We are committed to providing you with the best quality and cheap food service for different events"
      },
      content: {
        title: "Contact us",
        phone: "Telephone：64586539",
        whatsapp: "WhatsApp: 64586539",
        address:
          "Address：Flat 12D, Block 1 Camel Paint Building, 62 Hoi Yuen Road, Kwun Tong",
        email: "Emali：cateraway.cs@funmaxhk.com",
        title2: "View our social platform"
      }
    },
    menu: {
      title: "Valentine's Day Menu",
      title1: "Father's Day Special Set",
      btn1: "WhatsApp Order",
      btn2: "Order Now",
      banner: {
        h: "New arrival experience",
        p:
          "We are committed to providing you with the best quality and cheap food service for different events"
      },
      mainMenuTitle:"Catering HK Hot Picks",
      span: {
        title1: "70+",
        content1: "More than 70 choices of dishes",
        title2: "400+",
        content2: "Served 400+ companies‘ activities",
        title3: "1,000,000+",
        content3: "Deliver catering services to 1,000,000+ customers",
        title4: "Point-to-point delivery",
        content4: "Catering HK home delivery service"
      },
      h2: "Food Catering Menu For Your Need",
      seo: {
        h1: "To the menu",
        h2: "Peace to the meeting",
        span1:
          "To the family has always used innovative thinking and methods in the design of the menu, each food has been tested many times, so that your activities can be more perfect. When we arrived at the club, we designed each of our menus, which were developed by our Chinese chefs, Western chefs and Thai chefs. Each chef has an average of at least 10 years of kitchen experience. Therefore, many guests are very satisfied with our menu. Guests agree that our menu is very average and has the characteristics of food from all over the world. And we also have different types of vegetarian food to meet the needs of a group of vegetarians in Hong Kong. At the meeting, the company has always used innovative thinking and methods in the design of the menu. Each food has been tested many times. It has been taught by Chinese and Western chefs for more than ten years, and specially invited Thai chefs. Helping to create a favorite of vegetarians in Hong Kong.",
        span2:
          "In addition, we have different types of attendees, including private parties, business parties, children’s birthday parties, boat P to the club and luncheons, etc. The types of menus are only about $82/ You can taste the delicious food. And every type of arrival type meal, we will have a relatively cheap price, so that you can choose the right meal according to your event. In each of the attendance menus, we will add corresponding attendance services according to the activities of the guests. For example, during the luncheon, we can provide waiters and serve guests, and the corresponding drinks and other menus. Claim."
      }
    },
    christmas: {
      // titleZH: "Sitback & Chillax/HK,KLN and NT Catering Door to Door Delivety!",
      titleZH: "屬於香港人的 自選美食到會",
      h1: "Best Christmas Catering",
      h2: "Cateraway is the pick of catering companies for Christmas Parties",
      btn: "Shop Now",
      section1h2: "Best choice for Christmas party",
      e: {
        "h2": "Christmas Catering Menu",
        "h22": "(Christmas catering menu will be available from December)",
        "h3": "Turkey, Puddings and All You Need For X’mas",
        "h33": "Deliver to Whole Hong Kong",
        "btn": "Order Now"
      },
      section2h2: "Must-Eat At Your Christmas Party",
      section2h3_1: "Fettuccine with Assorted Seafood in Tomato Sauce",
      section2h3_2: "The best roast turkey",
      section2h3_3: "Buffalo Chicken Wing with Cheese",
      section2p1:
        "This seafood pasta is made of shrimps, clams and mussels, all tossed together with fettuccine in a homemade tomato sauce. An easy yet elegant meal, perfect for your Christmas party!",
      section2p2:
        "How can you have a Christmas without Turkey? Ours made by brining a whole turkey in black tea for 24 hours, before slow-roasting it. It is a must-eat for Christmas parties!",
      section2p3:
        "This Buffalo chicken wing with cheese is a perfect match! It is just so yummy that everybody wants a treat!",
      section3h2: "Tailor-made Christmas Party cuisine",
      section3p:
        "By the way, remember to order our special earlier to avoid last minute dissapointment during festive season.",
      tip: "Order your Christmas special with Cateraway now!",
      whatsapp: "WhatsApp Order",
      context:{
        h2TitleOne:"一年一度聖誕到會，美食必不可少",
        pContentOne:"我們會設計限定的聖誕到會菜式，這份餐單上的食物，大部份都是只出現在聖誕這個特別的日子中，所有不要錯過在聖誕節期間找我們落單！我們今年的聖誕節到會，會在12月1日開始至到12月31日，將聖誕節氣氛帶到整個月。聖誕節火雞更是必吃的食物，我們的火雞是經由具30年西式菜式經驗的廚師親自主理，聖誕餐單的設計更是加入了聖誕元素，您會不難發現在食物中會見到不少的聖誕主題的食物，包括聖誕原隻燒火雞、聖誕乳酸爆珠雜果沙律、聖誕cupcake，聖誕限定火雞沙律配蕃茄莎莎醬、聖誕糖果麵包布丁等等，為您的聖誕美食帶來更濃厚的氣氛！",
        pContentOneSecond:"提提您，記得提早預訂食物，因為有些日子真的是售完即止喔！如果是公司的客戶，就更加要早一點預訂，不然會給您的上司責備為什麼沒有好吃的食物過聖誕節！如果您有朋友和您一起過聖誕節，就記得為您的朋友們預早訂聖誕到會迎接節日來臨！"
      },
      aboutChristmasTitle:"關於訂購聖誕到會 - 常見問題:",
      aboutChristmas:{
        faq1:"1. 有什麼必吃的聖誕到會菜式？",
        content1:"傳統聖誕大餐必食食物一定要數到火雞，只要端上火雞於餐桌上，即時能感受到滿滿的聖誕氣氛。",
        faq2:"2. 我們的聖誕到會有什麼招牌菜式？ ",
        content2:"我們提供聖誕必吃的原隻燒火雞，還有非常惹味的水牛城雞翼、海鮮寬條麵等等。",
        faq3:"3. 訂購我們的聖誕到會有什麼需要注意？",
        content3:"在這個歡欣的節日裡，不少人都會舉行派對並預訂聖誕到會招呼親朋戚友。而為保持質素，我們在每個日子會製作限定數量的聖誕到會，售完即止。為免落空，謹記提前預訂！"
      },
    },
    christmase: {
      "h2": "Christmas Catering Menu",
      "h22": "(Christmas catering menu will be available from December)",
      "h3": "Turkey, Puddings and All You Need For X’mas",
      "h33": "Deliver to Whole Hong Kong",
      "btn": "Order Now"
    },
    christmase2: {
      "h2": "Christmas Special Menu for 4-6 Persons",
      "h22": "(Christmas catering menu will be available from December)",
      "h3": "Free Delivery",
      "h33": "Good for private or house parties",
      "btn": "Order Now"
    },
    birthday: {
      banner: {
        h: "Birthday will be",
        p: "To the home service more than 100+ different sizes of activities",
        btn: "Order Now"
      },
      content: {
        h: "Birthday will be",
        span1:
          "To the home of the family’s main birthday for many years, the children‘s menu design has added a variety of delicious and healthy children’s food, the purpose is to enable parents to host a birthday party for children, children can have fun And healthy. At the same time, parents also have a choice of alternative flavors to choose from. ",
        span2:
          "Our children‘s food is mainly healthy and less oil, less sugar and less salt. The food includes vegetarian cheese, buckwheat tomato salad, fresh honeydew melon and honeydew melon skewer, Swiss hormone-free chicken middle wing, and green melon protein. Stir-fried brown rice and steamed pumpkin sweet potato (with natural raw honey) and so on. For the sake of children’s health, we add fresh eggplant and meatball spaghetti. This feature is full of hands and no viscera. It is not like the meatballs of the company. It is added to different parts and internal organs. Created. In addition, our menus are also added with hormone-free meat and egg foods. In the process of children having a happy birthday, health can be guaranteed! ",
        span3:
          "To the home is definitely the first choice for children‘s birthday, to provide cost-effective, delicious and healthy food for your children’s birthday! Parents will hurry up for your family‘s baby and have an unforgettable birthday party."
      },
      context:{
        h2TitleOne:"大人、小朋友生日會，享受美味健康食物",
        pContentOne:"我們主營大人、小朋友生日到會多年，特別於小朋友到會餐單中加入多款美味及健康的小朋友食物，目的是令到家長們辦小朋友生日會時，小朋友都可以吃得開心和健康。與此同時，家長們亦有自選區可以選擇另類風味的滋味食物。",
        h2TitleSecond:"小朋友生日到會 健康最重要",
        pContentSecond:"我們的小朋友區食物以健康和少油、少糖、少鹽為主，食物包括素芝士藜麥蕃茄沙律、鮮蜜瓜及哈蜜瓜串、瑞士無激素雞中翼、翠肉瓜蛋白炒糙米飯及蒸南瓜蕃薯（配天然原蜜）等等。我們為了小朋友的健康著想，加設鮮茄手打肉丸意大利麵，這款麵的特色是全人手打及完全沒有內臟肉，不像外面一般到會公司的肉丸般，加入不同的部位及內臟打造而成。另外我們的餐單更加入無激素的肉類及蛋類食物，更為小朋友在生日中吃得開心的過程中，健康可以得到保障！",
        h2TitleThird:"快速下單 點對點送貨",
        pContentThird:"我們絕對是小朋友生日時的食物推介首選，為您的小朋友生日會提供性價比高、美味及健康的食物！家長們無需花時間準備食材親自下廚，所有生日會食物將交由我們為您一一辦妥。而再進一步減省各位家長的煩惱，我們提供方便快捷的訂購方法，您可以透過網上下單，或是以WhatsApp與我們的專員聯絡，只要告訴我們欲訂購之食物內容、聯絡方法、送貨地點等資料，豐盛的生日到會就會於指定日子送到府上，您將無需為準備孩子的生日會食物而感到懊惱。家中的孩子正期待著吧？各位家長們，趕緊為您們家的寶貝舉辦一個難忘的生日會吧！",
      },
      aboutBirthdayTitle:"關於訂購聖誕到會 - 常見問題:",
      aboutBirthday:{
        faq1:"1. 為何選擇我們的生日到會？",
        content1:"我們的生日到會不單單只是供應食物，我們的廚師於設計菜式時費盡心思，例如在為小朋友生日會製作套餐時，盡量加入少油、少糖、少鹽食物，亦會使用無激素的肉製品及蛋類食物，讓孩子能吃到健康又美味的食物。",
        faq2:"2. 我們的生日到會只適合小朋友生日會？ ",
        content2:"當然不是，雖然我們的生日到會餐單有專為小朋友而設的菜式，但同時我們亦有提供傳統生日到會必吃的推介食物，例如不同味道的雞中翼、意粉、炒飯、三文治等等，任君選擇，大人小孩都適合。",
        faq3:"3. 我們的生日到會適合多少人食用？",
        content3:"我們的生日到會套餐種類多元，適合不同規模的小朋友生日會，少至10人、到20人、30人、40人，甚或是多達60人的聚會，我們都有相應的套餐供應，總有一款適合您。",
        faq4:"4. 哪些場合適合訂購生日到會？",
        content4:"除了家長們為孩子舉辦的小朋友生日會外，其他場合如校園、教會或公司要舉辦生日派對，亦可以選擇向我們訂購生日到會，交由我們為您辦妥派對中所有膳食需要，而您能專注於規劃派對其他細節，無需操心。"
      },
    },
    junk: {
      banner: {
        h: "Junk Boat Party Catering",
        p: "Cateraway provides catering services for more than 1000+ Junk Boat private parties",
        btn: "Order Now"
      },
      content: {
        h: "Boat the river to the meeting",
        span1:
          "Every year from June to August, it is a big holiday for everyone to go to the boat P and open the party! Presumably you will open Party 3 times at least during the summer! Every time you sail the River Party, you will call the price to go to the boat to eat, but it should be easy to find that most of the food you call the boat is a large dish, and a large group of people are eating a few Up to ten foods! Choosing less and the taste of food must be the memory of your last boat P! However, if you choose to go to the club, you can taste 30 people and 30 models of super delicious and peaceful price, no longer worry about the problem of less style.",
        span2:
          "To the recommended boat to the meeting, the food includes: BBQ honey garlic fried chicken wings, charcoal pork neck meat with sauce chicken, Japanese char-grilled chicken skewers, French wine, mixed vegetables, sirloin, Italian Chocolate powder, puffs, smoked duck breast, cucumber, salad, salad with tomato, sand sauce, Japanese flax, three-color cold udon, Kabangi bacon, long-pass powder, Sicilian fresh fungus, squid, spaghetti, etc. I suggest that if you are a ship P, remember to choose more snacks for your party, because you can make everyone happier! ",
        span3:
          "The delivery area to the clubhouse is basically all the terminals can be delivered, including Kwun Tong Ferry Pier, Sai Kung Ferry Pier, Tsim Sha Tsui Ferry Pier, Western Central Pier, etc., to deliver the most delicious food for your party!"
      },
      main_section1: {
        h2: "親朋戚友開船P必食到會套餐",
        h3: "10 - 30人套餐應有盡有！",
        h4: "Order Christmas Party Catering",
        h5: "Party Food Catering Happy Celebrate with Your Friends",
        btn: 'Order Now',
      },
      main_section2: {
        h2: "Must-Eat At Your Junk Boat Party",
        meun1: "Classic Caesar Salad",
        meun2: "Fried Garlic & Honey Chicken Wings",
        meun3: "Crispy German Pork Knuckle with Yellow Mustard",
        p1: "Every delicate piece of crisp Romaine Lettuce is mixed with shaved savory crispy bacon bits and topped with crunchy croutons. Flavor with either Caesar Salad dressing to take the delicious authentic taste to another level. Perfect for your Junk Boat parties!",
        p2: "How can you have a Junk Boat Parties without Fried Garlic & Honey Chicken Wings? This chicken wing with barbecue honey is a perfect match! It is a must-eat for Junk Boat parties!",
        p3: "This Crispy German Pork Knuckle with Yellow Mustard is a perfect match! It is just so yummy that everybody wants a treat!",
        btn: 'Order Now',
      }
    },
    wedding: {
      banner: {
        h: "Wedding Catering",
        p:
          "Cateraway provides catering services for more than 100+ wedding parties",
        btn: "Order Now"
      },
      content: {
        h: "Wedding Catering For You",
        ctitle1: "Professional Wedding Catering Services",
        ctitle2: "A tailor-made menu that surprises all your guests",
        span1:
          "Whether you are planning for a traditional wedding dinner, wedding banquet, or a modern wedding food station, we will guide you through the thorough wedding catering planning process to build an unforgettable gourmet for your perfect day. ",
        span2:
          "Cateraway offers a wide range of wedding catering selections. The cuisine choices range from Thai, Chinese, Western to Vegetarian. With the detailed planning process with you, we make sure the wedding catering service will fit your wedding theme. From the wedding reception, lunch or cocktail parties, to traditional wedding dinner or banquets, we provide all-rounded catering services to your wedding day.",
        span3:
          "Our catering experts have thirty years+ catering experience. Cateraway has been the catering service partner for plenty of well-known clients including FWD, HKU, Clockenflap, and a lot more. We are dedicated to providing the best catering service for your wedding. Consult our catering specialist and order now!"
      },
      context:{
        h2TitleOne:"婚禮到會，經驗豐富",
        pContentOneFirst:"我們公司成立多年，亦都很有幸可以見證了很多對新人結婚。現在結婚的新人愈來愈多是走著西方文化的婚禮。每每都是請了一班親朋好友，在一個充滿花草和西式氣氛的環境下舉行婚禮。而新人們會訂一些精美的菜式，不像中式般一圍圍坐底慢慢吃中式食物，而是大家舉起酒杯，拿著一杯杯的精美食物交談和分享新人的喜悅。西式的wedding party正是以美酒配佳餚來慶祝，所以婚禮到會方面是需要更著重食物的配搭！",
        pContentOneSecond:"而我們正是在婚禮到會這一方面是有豐富的經驗，設計很多的餐單是符合您的婚禮party，另外我們還可以與您進行一對一的訂制服務，可以根據您的婚禮到會推介更美好的食物，或者如果您有想要的wedding美食，我們都可以烹飪出來。只要您想得出的美食，我們都會設計得更好和更美味。",
        pContentOneThird:"我們推薦給您的食物包括: 巴馬火腿露荀卷、鮮蝦芒果他他杯、香草鮮野菌生菜杯、甜蝦蕃茄莎莎杯、迷你蝦肉小漢堡、迷你三文魚生菜沙律牛角酥及法式精緻小甜點拼盤。",
      },
      aboutWeddingTitle:"關於訂購婚禮到會 - 常見問題:",
      aboutWedding:{
        faq1:"1. 為何我們是首選的婚禮到會推介？",
        content1:"我們擁有多年製作婚禮美食的經驗，質素與味道是我們認為最重要的兩大關鍵，我們用心準備每一張訂單、每一道菜式，務求給予客人完美的餐飲體驗。除美食外，我們還提供更多貼心服務，包括保溫熱爐為食物保暖、酒水香檳選擇等等。",
        faq2:"2. 我們有什麼婚禮到會推介食物？",
        content2:"婚禮食品必須美味、精緻，能吸引食客，我們特別設計各種賣相體面又可口的婚禮小吃，婚禮到會推介食物包括: 鮮蝦芒果他他杯、迷你蝦肉小漢堡、法式精緻小甜點拼盤等等。",
        faq3:"3. 我們提供婚禮到會自訂服務嗎？",
        content3:"為求盡善盡美，不少新人都希望加入自己喜歡的菜式於餐單中，因此我們提供一對一訂制服務。我們專業團隊將聆聽您的需要，盡力為您設計出一道道婚宴美食。",
      },
    },
    snacks:{
      banner:{
        title:"到會小食",
        subTitle:"服務超過100+不同大小的活動"
      },
      context:{
        h2TitleOne:"到會小食份量剛剛好，不太飽肚",
        pContentOneFirst:"有些時候如果您想為您的party選擇一些不太飽肚的到會食物，您可能會想要小食類別比較多的餐單。可是，傳統公司一般會將主食和小食等等放在一起，令到客人們需要強制性訂購整個套餐，造成不必要的浪費和與活動性質不對稱。",
        pContentOneSecond:"我們有別一般傳統公司，我們特別設計皇牌餐單，有到會小食及拼盤自選區，您可以在近二十款的小食中選您想要的食物，選擇極多元化。另外我們還有甜品、沙律、冷盤及烘焙包點等等的小食，您可以為您的活動場合選上合適的食物。我們的小食種類繁多，而且是具有多國特色的食物，包括泰式、中式、西式和日式等等。選擇我們到會小食的客人一般場合是茶會、商務會議、下午茶餐及船河等等，如果您正在為您的公司或朋友舉辦派對，需要準備美食及小食，就不容錯過我們的到會小食，歡迎向我們查詢！",
        pContentOneThird:"到會小食推介：粟米碎蛋沙律三文治、香濃芝士豆腐、蒜香蜜糖BBQ雞翼、香脆炸蟹鉗拼吉列帶子、炸粟米墨魚餅拼香燒雞肉丸、新鮮手切串燒波蘿配朱古力醬、日式和果子拼盤（紅豆，抹茶，黑糖）、一口台灣腸等等",
      },
      aboutSnacksTitle:"關於訂購到會小食 - 常見問題:",
      aboutSnacks:{
        faq1:"1. 為何選擇我們的到會小食？",
        content1:"傳統到會食物以主食為多，如飯類、麵類，較少有專屬的到會小食餐單。而事實上，小食往往是眾多食品中最受歡迎的類型，我們就打破傳統框架，專門提供小食系列，有近二十款菜式，讓客人能夠享有更多選擇，來一場滋味盛宴。",
        faq2:"2. 我們有什麼必嚐的到會小食？",
        content2:"我們的每一款到會小食都是由廚師精心炮製，當中人氣之選不少得蒜香蜜糖BBQ雞翼、店揚椒鹽魷魚鬚、日式雞軟骨餃子、XO醬一口牛舌粒、日式明太子餃子雞翼等等。我們的廚師更會定期推出全新菜式，保持新鮮感，讓客人每次都能夠吃到不一樣的食物。",
        faq3:"3. 如何訂購我們的到會小食？",
        content3:"我們提供多種訂購方法，您可選擇直接WhatsApp聯絡我們下單，或是透過我們的網站於線上訂購，只要揀選您想要的套餐、食物、數量，再輸入訂購人的送貨資料，就完成訂購手續，到會家專員將會聯絡您作訂單確認及跟進事宜。",
      },
    },
    chinese: {
      banner: {
        h: "Chinese Catering",
        p:
          "Cateraway provides you the best unique Chinese catering experience in Hong Kong",
        btn: "Order Now"
      },
      content: {
        divf: {
          p1: "CHINESE NEW YEAR CATERING Menu  Door to door free delivery",
          p2: "HOT POT Menu  Suitable for small group gathering with your family",
        },
        div1: {
          h1: "Specializing in traditional Chinese Catering Services",
          p1: "Each Chinese New Year, Chinese would like to share meals at home together with the beloved ones. Corporates would organize the company yearly gathering during this festive season.",
          p2: "Chinese New Year Catering service is your best option to welcome your guests. At Cateraway, we serve more than 50 Chinese dishes and hot pot specials.",
          p3: "Each Chinese New Year, Chinese would like to share meals at home together with the beloved ones. Corporates would organize the company yearly gathering during this festive season. Chinese New Year Catering service is your best option to welcome your guests. At Cateraway, we serve more than 50 Chinese dishes and hot pot specials."
        },
        div2: {
          h1: "Tailor-made Chinese food catering menu for you",
          p1: 'Cateraway provides special Chinese Catering menus. These menus are carefully crafted by chefs with 30+ years of experience in Chinese cuisine. Share your meals with your friends and families warmly with Cateraway. In addition, we can also tailor-made Chinese New Year menus based on what you need.'
        },
        div3: {
          h2: "Order your Chinese Catering with Cateraway now!",
          btn: "WhatsApp Order"
        }
      },
      context:{
        h2TitleOne:"超過三十年中菜經驗的廚師，為您設計中式到會菜式",
        pContentOneFirst:"不知大家是什麼時候會訂中式到會呢？我們相信您叫到會的時候，會有一些長輩等等在場的場合。中式到會是十分適合您們家中的年長一輩吃的，您可能會想訂一些素食、齋、廣東菜等等的食物。但是最常見是在酒樓才可以吃到，叫回家吃的場合相對較少。但除著人們的生活習慣改變，您們的節日可能想留在家裡吃美味的中式食物，而不想和別人在街外等位。中式到會的確是合適送到您們家裡，而我們亦可以製作出美味的中式食品，為您的家庭聚會增添更多的美食。",
        pContentOneSecond:"每逢新年、中秋及聖誕佳節，很多客人都會想在自己家裡煮一些食物，如果親朋好友太多的話，想必煮的那位媽媽都會很辛苦，所以客人為向我們訂中式到會送到府上作為「加餸」。新年最常見的是加一個盆菜和大家一起吃！我們的中式到會除了可以滿足您家裡的每一餐外，我們還可以為您的公司煮出美味的應節食物。我們曾服務過一次超過50枱的中式圍餐及盆菜，而且我們有即場廚師為他們製造不同的美食！",
      },
    },
    western: {
      banner: {
        h: "Western style to the meeting",
        p: "To the home service more than 100+ different sizes of activities",
        btn: "Order Now"
      },
      content: {
        h: "Western style to the meeting",
        span1:
          "There are many chefs who have come to the club for more than 20 years of Western food experience. How to integrate Western-style thinking into a Menu is a problem that we have always needed to break through. Western-style clubs are most commonly used in foreign countries for baking and snacks, but if you take the whole method to Hong Kong, you may not be satisfied with all the guests. Hong Kong people will want to order some staple foods, and these staple foods are mainly rice noodles. Because we want to integrate Western culture into the Hong Kong element. For example, when we design Western food, we will add Kabonni spaghetti, but Kabunni spaghetti will easily deteriorate during transportation. We have to change its traditional practices so that food can be delivered to guests. Keep it delicious on your hands. ",
        span2:
          "To the family’s menu, in addition to a plate of food, we also have fine Western snacks, cups of snacks and high-end business snacks. As long as you tell us what the company needs for your company‘s activities, we can make food according to your requirements.",
        span3:
          "Imperial Western-style snacks recommendation: a mini-smoked salmon burger, Caesar chicken salad, finger sandwiches, vanilla lettuce, fresh wild mushroom, branded cup snacks: smoked salmon, his cup, Hokkaido milk 360 milk jelly"
      },
      aboutWesternTitle: "關於訂購西式到會 - 常見問題:",
      aboutWestern: {
        faq1: "1. 我們的西式到會有什麼招牌推薦食品？",
        content1: "我們特別推薦美式BBQ醬烤原條豬肋骨、原隻香烤燒雞，德國香腸拼盤、炭烤串燒，這是都是西式到會必不可少的重要菜式。除此之外，我們提供不同味道的雞中翼，包括蜜汁、香蒜蜂蜜味、日式明太子味等，全都是人氣之選，保證讓您一試難忘。",
        faq2: "2. 我們的西式到會有什麼食品類型可選？",
        content2: "西式到會多元，我們公司提供各類型西式美食，前菜就有各式冷盤、沙律、小食，主菜方面有意粉、焗飯、燒雞、扒類等等，當然不少得甜品，如泡芙、馬卡龍。我們的西式到會食物種類包羅萬有，定必照顧得到不同客人的口味需要。",
        faq3: "3. 我們的西式到會有何優勢之處？",
        content3: "在西式到會餐單上的每一款菜式，均由我們精心製作。我們嚴選食材、注重食物質素。當然，食物的賣相及味道對我們及客人來說固然重要，但我們於設計菜式上更會考量到運送食品中的注意事項，確保食物送到客人手中後依然美味。",
      },
    },
    thai: {
      banner: {
        h: "Thai style will come to the meeting",
        p: "To the home service more than 100+ different sizes of activities",
        btn: "Order Now"
      },
      content: {
        h: "Thai style will come to the meeting",
        span1:
          "Thai style is a rare type of meeting in the market. Thai cuisine is difficult to master, and there are many kinds of spices. The Thai food to be colored needs color, aroma and taste in the food. Generally, non-Thai restaurants can only cook the food hard and send it to the guests’party. The guests are more likely to choose traditional Thai cuisine.",
        span2:
          "To the family‘s menu, in addition to a plate of food, we also have fine Western snacks, cups of snacks and high-end business snacks. As long as you tell us what the company needs for your company’s activities, we can make food according to your requirements.",
        span3:
          "The Thai restaurant is also opened to the club‘s head office. This Thai restaurant is also a famous restaurant in Kwun Tong. Our Thai menu is also developed by Thai restaurant chefs. All Thai styles are completely Thai, so you can find boneless Thai Hainan chicken and Thai in our menu. Fried ginseng powder, Thai pork neck meat, traditional pineapple fried rice and coconut juice layer cake. And some of our dishes are also made by the chefs every day. The hand-picked shrimp cake is a must-eat snack for our emperor. Thai pork neck meat is more delicious.",
        h2: "Thai style will be recommended",
        span4:
          "Appetizer: Thai Emperor spicy fried minced lettuce bag, Thai hot and sour boneless chicken feet",
        span5: "small food: Thai pork neck, hand-shrimp cake",
        span6:
          "Staple food: fragrant leaf chili pork fried rice, traditional pineapple fried rice, the original boneless Thai Hainan chicken",
        span7: "Dessert: a mango glutinous rice, coconut juice layer cake"
      },
      aboutThaiTitle: "關於訂購泰式到會 - 常見問題:",
      aboutThai: {
        faq1: "1. 我們的泰式到會有什麼招牌菜？",
        content1: "說到泰式招牌菜，必定會有蝦餅、生菜包、炒金邊粉，我們的泰式到會當然不會錯過這幾道泰式必備菜式。除此之外，我們的廚師特別炮製泰式酸辣無骨鳳爪作為開胃前菜，亦有滋味小食原隻酥炸豬手、無骨泰式海南雞、香口飽肚的香葉辣椒豬肉碎炒飯等等一系列泰式美食。",
        faq2: "2. 我們的泰式到會有什麼食品類型可選？",
        content2: "我們的泰式到會包羅萬有，從泰式沙律，到傳統泰式小食如泰式蝦片、泰式豬頸肉等，主食有炒飯、炒金邊粉等等。除沙律、小食及主食外，當然不少得同時深受大人小孩喜受的泰式甜品。",
        faq3: "3. 為何選擇我們的泰式到會？",
        content3: "傳統到會食物菜式選擇有限，不外乎中式或西式，而我們有別一般公司，會為食品增添新意，因此特別提供泰式到會，讓熱愛泰國菜的朋友可於聚會上品嘗得到與別不同的食物。",
        faq4: "4. 我需要提前預訂到會家的泰式到會嗎？",
        content4: "需要。如欲訂購我們的泰式到會，請提前兩天下單。您可透過網上訂購表格或WhatsApp專線與我們的專員聯絡。",
      },
    },
    vegetarian: {
      banner: {
        h: "Vegetarian to the meeting",
        p: "To the home service more than 100+ different sizes of activities",
        btn: "Order Now"
      },
      content: {
        h: "Vegetarian to the meeting",
        span1:
          "In the past 10 years, more and more people have begun to pursue the vegetarian trend. Whether they are young people, working people or retirees, many of them will support vegetarian food because of the ecological environment of animals and their love and personal health. Think about and contribute to the earth’s environmental protection. There are also two types of vegetarians, namely vegetarian and vegan. In order to cope with this upsurge, many companies will join the vegetarian diet to the category of food, or meat food to meet the needs of customers. And we went to the club to take the initiative to develop new and exquisite vegetarian food to the meeting, to bring food to a group of friends who do not eat meat.",
        span2:
          "In addition to the meat-free selection in the official menu, we can also cook Chinese vegetarian and Western vegetarian. The food of the fast food is the representative of the Chinese vegetarian food. In addition to the good Chinese cuisine, our Chinese chef is also our best food. For Western-style vegetarianism, our company has also opened a vegan western-style restaurant in Central, which combines western-style special-style vegetarian food to attract many working families in the Central Business District. Therefore, our vegetarian diet will be desperate for foreign guests and those who like Western-style vegetarian food to order."
      },
      aboutVegetarianTitle: "關於訂購素食到會 - 常見問題:",
      aboutVegetarian: {
        faq1: "1. 素食到會淡而無味、菜式單調沉悶？",
        content1: "很多人對素食到會都有誤解，認為素食味道必定清淡，菜式亦只有蔬菜水果，款式不夠肉類多元。這個想法大錯特錯，菜類、豆類、瓜類有上千百種，只要用心烹調，自然能製作出美味食物。我們的廚師擅長設計素食菜式，亦有多年烹煮素菜經驗，是首選的素食到會供應商。",
        faq2: "2. 素食到會不夠營養？",
        content2: "不少人對素食到會有另外一些誤解，如不夠營養、肌餓感不斷。其實，素食能提供身體所需營養，如蛋白質與鐵質就能分別於豆類及綠葉蔬菜中汲取。",
        faq3: "3. 素食到會容易產生飢餓感、很快再肚餓？",
        content3: "的確，肉類脂肪較多，胃部需要較多時間消化，因此飽肚感會較持久。而蔬果一般消化時間較短，故容易有肚餓感。不少素食者會進食高纖維食物，如豆類，以延長飽肚感。我們亦有提供高纖維素食菜式，讓您吃畢後飽足感滿滿。",
        faq4: "4. 我能夠同時訂購素食與非素食到會嗎？",
        content4: "當然可以，我們深明不同人士有不同的飲食喜好，有些客人無肉不歡、有些客人則堅持茹素。透過我們，您將能滿足各人的食物要求。只要將所希望訂購的素食款式告訴我們，我們的專員將與您商討菜式，並盡力為您安排。",
      },
    },
    bento: {
      banner: {
        h: "Bett",
        p: "To the home service more than 100+ different sizes of activities",
        btn: "Order Now"
      },
      content: {
        h: "Bett",
        span1:
          "But was originally a lunch prepared by Japanese housewives for their husbands and children, and this culture has since spread to all parts of the world and Hong Kong. In Hong Kong, the occasions where we have a common lunch are lunch, and the occasions that need to be ordered are usually lunch time in the middle of the company‘s business meeting. The food in a lunch box, including hors d’oeuvres, snacks, staple foods and desserts, can be done very delicately. A beautiful lunch box is indeed the heart of the producer who is eating. If it is a couple, it is a love lunch box, and there will be heart-shaped rice balls and heart-shaped love eggs. If it is the love of the mother, it must be richer. Every food is the mother‘s love for the children. And if it is the lunch box that we cook at the house, it is our heart for everyone who eats. We hope that every guest can have a very satisfying feeling after eating. You will feel that this is not the same lunch box as a regular tea restaurant. It will be a lunch box bearing love and heart!",
        span2:
          "To the club will be willing to design a perfect lunch for every colleague and boss of your company, this will be an experience from the former to the dessert. If you would like to order a lunch for your company, please contact us!",
        span3: "我們願意會為您的公司每一位同事和上司設計一份十分完美的午餐便當盒，這將會是從前菜到甜點的一份體驗。如果您想為您的公司訂製午餐飯盒，歡迎聯絡我們！",
      },
      aboutBentoTitle: "關於訂購便當到會 - 常見問題:",
      aboutBento: {
        faq1: "1. 我們的便當訂購服務適合哪些場合？",
        content1: "我們的便當訂購服務適合各種場合，常見場合包括公司會議、公司內部聯誼、學校聯歡聚會、教會聚會、生日派對等等。一份美味精緻的便當能拉近人與人之間的距離，藉著美食，同事、朋友一同吃飯聊天，增進感情。",
        faq2: "2. 我們的便當到會有什麼食物選擇？",
        content2: "我們的便當盒主要提供粉麵及飯類，從西式、日本風味，到泰式、馬來西亞，任君選擇。除了粉麵及飯類便當外，您亦可以選三文治便當或小食便當盒。另外，我們提供多格餐盒便當，同一個便當內有多於一款菜式，即除主食外，會配有沙律、雜菜、小食等食物，讓公司便當更豐富更吸引。\n",
        faq3: "3. 有什麼必吃的便當推薦？",
        content3: "我們的便當推介選擇多元，喜歡日本和風的客人可選日式照燒雞扒飯、日式蒲汁鰻魚辣炒飯等；泰菜之選有泰式菠蘿海鮮炒飯、泰式炭燒豬頸肉飯；想品嚐馬拉風味的客人可以嘗試馬來西亞咖喱牛腩飯；西餐類我們特別推薦經典的卡邦尼煙肉燴意粉、義大利肉醬意粉、珍珠帶子墨魚汁意粉等。在眾多款式之中，您定能找到所喜愛的便當盒。",
      },
    },
    central: {
      banner: {
        h: "Central to the meeting",
        p: "To the home service more than 100+ different sizes of activities",
        btn: "Order Now"
      },
      content: {
        h: "Central to the meeting",
        span1:
          "Central is Hong Kong’s commercial center and transportation hub. It is also a gathering point for multinational companies. We can see restaurants in various countries including France, the United States, Spain, Portugal and other multi-national dishes in Central. It‘s a dazzling array of dishes, whether it’s a different style of Fingerfood, main course or dessert, it‘s a food sacred place worth punching! The tastes suitable for people of different nationalities are a symbol of the convergence of Chinese and foreign cultures. Calling in Central is like a trip to a different country. It’s just that the journey depends on the individual. You can go to the US and then to Japan. Europe or go to Europe before going to Japan! ",
        span2:
          "The Central Conference is more suitable for different occasions. We have also participated in many large-scale events in Central in the past, including the Clockenflap Music and Culture Festival, AIA Carnival, Central Sun Theatre, 18+Central and Old Master Marathon. The range of services to the club is very wide and the recognition in the industry is very high. If you want to feel the taste and taste of different countries by going to the food, call the club!"
      }
    },
    eastern: {
      banner: {
        h: "North Point to the meeting",
        p: "To the home service more than 100+ different sizes of activities",
        btn: "Order Now"
      },
      content: {
        h: "North Point to the meeting",
        span1:
          "North Point is a place with a very historical charm. The local gathering of very historic schools and chambers of commerce. At the Cateraway, two Chinese and Western chefs with 20 years of experience were invited to attend the conference, and they were dedicated to studying the various chambers and schools in North Point. The Chamber of Commerce has a lot of activities to enjoy our services such as cocktail parties, large-scale business meetings, boat P, banquets, regular meetings, etc. within the scope of our services, and the school’s festival party, school games, open days, etc. Have a lot of service experience.",
        span2:
          "We have a purpose at the meeting: today is a little better than yesterday. The two chefs believe that today‘s craftsmanship is accumulating with the first half of the body. There are no shortcuts and no other tricks. From learning, practice, practice and innovation to the present day. We believe that the customer’s tongue has always been treated equally, and it is difficult for the customer to tell a good food loss piece! We want customers to be able to eat is not simply a taste of food is so simple, I want customers to eat out the chef to the North Point to cook a kind of obsession!"
      }
    },
    wan: {
      banner: {
        h: "Causeway Bay to the meeting",
        p: "To the home service more than 100+ different sizes of activities",
        btn: "Order Now"
      },
      content: {
        h: "Causeway Bay to the meeting",
        span1:
          "The Causeway Bay is a diversified commercial area with a variety of commercial, restaurant and entertainment venues. Many commercial activities take place in this small area. At Cateraway, we asked the Western-style chef who had 20 years of experience in Causeway Bay to produce dishes from different countries to Causeway Bay! From the company lectures, sharing sessions, banquets, ceremonies, yacht clubs and other activities to provide catering services.",
        span2:
          "We have a series of procedures from the front dish, staple food, snacks and desserts, food selection, processing procedures, packaging, etc., to ensure that each dish can present the customer‘s eyes in the most perfect posture. . We also often learn how to cook in different countries. You will see that we include Italian, Japanese, Chinese, Western and Thai food types in the menu, in order to make the styles on the menu. More diversified and more distinctive! ",
        span3:
          "We believe that cooking should not simply express the taste, but express the chef’s understanding and respect for the national culture. In addition to making mouth-watering dishes, we want to taste us more to make customers feel. The feeling of being respected!！"
      }
    },
    sham: {
      banner: {
        h: "Changsha Bay will meet",
        p: "To the home service more than 100+ different sizes of activities",
        btn: "Order Now"
      },
      content: {
        h: "Changsha Bay will meet",
        span1:
          "Changsha Bay and Lai Chi Kok are a place where business, residential and industrial are gathered. In this place we can see different costumes. Although everyone has their own identity, the essence of our favorite food is never changed! Cateraway offers high-quality and affordable services for commercial, residential, industrial and other places. The menu includes special dishes from different countries such as Thailand‘s original pineapple fried rice, Bangkok hand-baked shrimp cake, and authentic Italian. Kabangi Changtong Powder is the hottest choice for Changsha Bay. To cater to the local taste of Changsha Bay, our chef has carefully selected spices and ingredients in Thailand and has the honor to exchange traditional Thai curry practices with local chefs. The dishes are all the chef’s dedication to cooking. The true meaning of the food is the basis for us to survive in many food and beverage industry. ",
        span2:
          "For the pricing of Cheung Sha Wan to attend the meeting and Lai Chi Kok, our chef insisted on benefiting the general public at a reasonable and cost-effective price. He once threatened that when I was young, I did not enjoy the right to food because of poverty. Now I am I have to do it if I have the right to give others this!"
      }
    },
    yan: {
      banner: {
        h: "Tsim Sha Tsui, Mong Kok to the meeting",
        p: "To the home service more than 100+ different sizes of activities",
        btn: "Order Now"
      },
      content: {
        h: "Tsim Sha Tsui, Mong Kok to the meeting",
        span1:
          "Tsim Sha Tsui and Mong Kok are the heart of Hong Kong. I remember that when I was young, I could find different specialties. However, with the change of society, all kinds of foods have begun to be simplistic, and most of the merchants who can afford expensive rents and labors are large food groups. Their dishes cannot be said to be good or not. It is said that it is difficult to eat, can only say that boring is too boring, most of them are in the factory ready to heat semi-finished products, in order to try new products are mostly short-lived and then no news.",
        span2:
          "You can try the dishes in different places now! Cateraway has selected dishes from different countries and regions to select the tastes suitable for Mong Kok and Tsim Sha Tsui. It has created unique dishes for the market in Tsim Sha Tsui and Mong Kok. The $82 can be seen from the start. , main course, snacks and desserts to package, sell, transport one-stop service. We also regularly incorporate new elements into the design of the menu so that all guests can taste the novel dishes after a while.",
        span3:
          "The pursuit of food is an attitude towards life. Our enthusiasm is to bring this attitude to you in need!"
      }
    },
    kwai: {
      banner: {
        h: "Kwai Chung to the meeting",
        p: "To the home service more than 100+ different sizes of activities",
        btn: "Order Now"
      },
      content: {
        h: "Kwai Chung to the meeting",
        span1:
          "Kwai Chung is a diversified area, and young people will go to the area to spend. The Kwai Chung Plaza is the place with the highest flow of people and the highest frequency of consumption. It gathers a variety of foods to attract guests from different regions. The Kwai Chung District is also one of the areas where we often deliver goods to the club. This area is similar to the Kwun Tong District and is an industrial area. We have cooperated with many Partyrooms in Kwai Chung, and many Partyrooms are also our merchants. If you are a frequent visitor to the Partyroom in Kwai Chung District, you should have eaten our meeting. Whether you are going to a family-style party or going to a workshop, you will be connected to Kwai Chung.",
        span2:
          "Residents of Kwai Chung District will also take the food they have eaten and share it with their families after they have eaten our meeting. If the average family is tired of eating pizza and fried chicken, you can choose our Royal Restaurant package, which contains Chinese, Western, Japanese and Thai food, and the style is more than 50 foods. The menu is very suitable for family bookings. If you want to order Kwai Chung to the food, in addition to the telephone reservation, you can also book food on our website, remind you to remember to book three days in advance!"
      }
    },
    sai: {
      banner: {
        h: "Tsim Sha Tsui, Mong Kok to the meeting",
        p: "To the home service more than 100+ different sizes of activities",
        btn: "Order Now"
      },
      content: {
        h: "Tsim Sha Tsui, Mong Kok to the meeting",
        span1:
          "Tsim Sha Tsui and Mong Kok are the heart of Hong Kong. I remember that when I was young, I could find different specialties. However, with the change of society, all kinds of foods have begun to be simplistic, and most of the merchants who can afford expensive rents and labors are large food groups. Their dishes cannot be said to be good or not. It is said that it is difficult to eat, can only say that boring is too boring, most of them are in the factory ready to heat semi-finished products, in order to try new products are mostly short-lived and then no news.",
        span2:
          "You can try the dishes in different places now! Cateraway has selected dishes from different countries and regions to select the tastes suitable for Mong Kok and Tsim Sha Tsui. It has created unique dishes for the market in Tsim Sha Tsui and Mong Kok. The $82 can be seen from the start. , main course, snacks and desserts to package, sell, transport one-stop service. We also regularly incorporate new elements into the design of the menu so that all guests can taste the novel dishes after a while.",
        span3:
          "The pursuit of food is an attitude towards life. Our enthusiasm is to bring this attitude to you in need! "
      }
    },
    tin: {
      banner: {
        h: "Sha Tin will meet",
        p: "To the home service more than 100+ different sizes of activities",
        btn: "Order Now"
      },
      content: {
        h: "Sha Tin will meet",
        span1:
          "Shatian is a self-sufficient community with different families. Our reason for being a family guest in Shatian is that we have a wide selection of foods, from top dishes to desserts with over 40 dishes. Moreover, when we design food, we have changed a lot of traditional food practices, and we have joined our chefs‘years of experience in food creation in different countries, so that the food that is easy to deteriorate in the delivery process is fresh and delicious! There is no meat choice in the menu, it is a must for some vegetarian friends. ",
        span2:
          "And in the order received from Shatian, we can see that there are more orders for children to choose. Many families with children will choose our meeting, because we have healthy food for children. We have added hormone-free meats, including hormone-free chicken wings, chicken chops, eggs, etc., and in terms of home desserts, we think of children’s intake of sugar, we have low-sugar gelatin to make children eat healthier. And we also have suitable sweet potato and pumpkin, broccoli, potato and so on, which make it easier for the elderly to digest.",
        span3:
          "To the club will be thoughtful for every member of your family, call or book online now!"
      }
    },
    tsuen: {
      banner: {
        h: "tsuen to the meeting",
        p: "To the home service more than 100+ different sizes of activities",
        btn: "Order Now"
      },
      content: {
        h: "tsuen to the meeting",
        span1:
          "The partyrooms in Tsuen Wan are gospel to La! Cateraway has launched a college student menu, a menu for children and adults for the local partyroom, and a $82 optional menu for desserts, staple foods, and snacks for different age groups. In order to create a happy and playful atmosphere, we will enter the current trend of young people into the Royal Choice menu. For children‘s menus, we specially invite nutrition experts to create a diet that uses hormone-free and balanced nutrition as a child. Special dining card. Desserts, staple foods, and snacks are suitable for all ages, regardless of the size of a family or a group of confidants.",
        span2:
          "We are at the top of the trend, we will launch a new trend menu every 6 months! Every time a customer has a different experience, it is like having a different travel experience every time. I have tasted Japanese food today. I can try Thai food next time, and then I can try French food next time. It’s our Tsuen Wan meeting!",
        span3:
          "Our aim is to present a thousand foods in front of us! Should this journey start in the United States or in Japan? "
      }
    },
    tuen: {
      banner: {
        h: "tuen to the meeting",
        p: "To the home service more than 100+ different sizes of activities",
        btn: "Order Now"
      },
      content: {
        h: "tuen to the meeting",
        span1:
          "The legendary Tuen Mun’s friend will have to go to the side for a minute and a half. Going to drink with friends and eating food will wait until the willpower breaks out! Now the friends who live far away need to go to the ends of the earth to find food! Cateraway offers a wide range of cuisines from all over Hong Kong, including the famous restaurants, trendy specialties, and punched desserts! We now have more than 300 partyrooms, different types of companies, charities and even hospitals. Our customers are welcome to choose one of the dishes, and you will be asked to pull a group of friends to try. More dishes!",
        span2:
          "We have set up a special team to meet the friends who are more convenient for transportation. The professional driver will send you the speed! Our 25-year-old Western chef said: I used to be poor when I was a child, so I had the opportunity to eat well. I have better food at Ikea. I want to share my dreams, because I should be young. Enjoy it, wait for the big left to talk to the children and grandchildren, haha!",
        span3:
          "The true meaning of food is not the taste, but the memories of youth!"
      }
    },
    yuen: {
      banner: {
        h: "Yuen Long to the meeting",
        p: "To the home service more than 100+ different sizes of activities",
        btn: "Order Now"
      },
      content: {
        h: "Yuen Long to the meeting",
        span1:
          "The most frequent meeting in the New Territories is the Yuen Long, and the 18th Township is the place we often send. We have also wondered why so many guests will choose to call to Yuen Long. The original Yuen Long area is a lot of independent houses. We have asked many old customers who told us that most of the gatherings are barbecue forms. There are also more preparations for work. Moreover, there are fewer choices for Yuen Long to attend the conference. Many guests need to call food across districts, but when they want to call the district, most of the companies will not send such remote places. But we went to the club but distributed all over Hong Kong, so we became one of the companies they often order! Our services to the clubhouse include Hong Kong and Kowloon New Territories, such as non-restricted areas or very remote areas, we will all be served. I remember that when I sent Yuen Long to the meeting, the delivery place could not drive in. Our professional driver walked the two boxes of food for 20 minutes and sent the food to the guests, but the guests were grateful to us. More motivation!",
        span2:
          "A self-selection to each of the members of the club is really suitable for your family gathering. If your family is a gathering of 20 people, you can choose 20 foods on our menu, absolutely The innovation in the market will make you happier!"
      }
    },
    setMenus: {
      Private: {
        name1: "Private/company party"
      },
      business: {
        name1: "Business activity"
      },
      children: {
        name1: "Children’s birthday is coming"
      },
      boat: {
        name1: "Boat P gourmet"
      },
      luncheon: {
        name1: "Luncheon party"
      },
      refreshments: {
        name1: "refreshments"
      }
    },
    dialog: {
      title1: "Contact Details",
      name: "Name",
      names: "Enter your full name",
      email: "Email",
      emails: "Vaild Email address",
      phone: "Phone",
      phones: "Vaild phone number",
      company: "Company",
      companys: "Enter your company name in full title",
      title2: "Event Details",
      eventDate: "Event Date",
      eventDates: "Please select a date",
      eventTime: "Event Time",
      eventTimes: "Please select a time",
      eventyLocation: "Eventy Location",
      eventyLocations: "Enter the detail of location",
      eumberOfGuests: "Number Of Guests",
      budget: "Budget",
      budgets: "Enter your budget",
      requiredFoods: "Required Foods",
      requiredFoodss: "Enter your required foods",
      servingstyle: "Serving style",
      servingstyles: "buffet, lunch box, etc.",
      bervage: "Bervage",
      bervages: "Please enter your required beverage",
      waiters: "Waiters",
      waiterss: "Please enter numbers of the waiters",
      requiredEquipment: "Required Equipment",
      requiredEquipments:
        "Enter you special request eg. Heat stove, Table. etc",
      otherRemarks: "Other Remark",
      otherRemarkss: "Please enter special request / arrangement",
      confirm: "confirm",
      cancel: "cancel"
    },
    zh: "中文繁体",
    en: "English"
  }
};
